import React from "react";

const DataLegend = () => {
    return (
        <div className="mt-10 w-full max-w-[1100px] mx-auto">
            <h4 className="font-semibold mb-3 text-lg">
                Data Legend
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                <div>
                    <span className="font-medium text-custom-light-grey">Wave Height:</span>
                    <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-blue-900/20 border border-blue-300 rounded"></div>
                            <span>0-1m (Small)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-green-900/20 border border-green-300 rounded"></div>
                            <span>1-2m (Good)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-yellow-900/20 border border-yellow-300 rounded"></div>
                            <span>2-3m (Great)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-orange-900/20 border border-orange-300 rounded"></div>
                            <span>3-4m (Big)</span>
                        </div>
                    </div>
                </div>
                <div>
                    <span className="font-medium text-custom-light-grey">Wind Speed:</span>
                    <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-green-900/20 border border-green-300 rounded"></div>
                            <span>&lt;10 km/h (Light)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-yellow-900/20 border border-yellow-300 rounded"></div>
                            <span>10-20 km/h (Moderate)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-orange-900/20 border border-orange-300 rounded"></div>
                            <span>20-30 km/h (Strong)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-red-900/20 border border-red-300 rounded"></div>
                            <span>&gt;30 km/h (Very Strong)</span>
                        </div>
                    </div>
                </div>
                <div>
                    <span className="font-medium text-custom-light-grey">Period Quality:</span>
                    <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-green-900/20 border border-green-300 rounded"></div>
                            <span>&gt;12s (Excellent)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-yellow-900/20 border border-yellow-300 rounded"></div>
                            <span>8-12s (Good)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-red-900/20 border border-red-300 rounded"></div>
                            <span>&lt;8s (Poor)</span>
                        </div>
                    </div>
                </div>
                <div>
                    <span className="font-medium text-custom-light-grey">Rating Stars:</span>
                    <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-purple-400 rounded"></div>
                            <span>5 stars (Perfect)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-green-400 rounded"></div>
                            <span>4 stars (Excellent)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-yellow-400 rounded"></div>
                            <span>3 stars (Good)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-orange-400 rounded"></div>
                            <span>2 stars (Fair)</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 bg-red-400 rounded"></div>
                            <span>1 star (Poor)</span>
                        </div>
                        <div className="text-xs text-custom-light-grey mt-2">
                            Based on your ideal conditions
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DataLegend;